// Internal Imports
import * as Tools from '../tools';
// d3 imports
import { extent } from 'd3-array';
import { scaleQuantize, scaleLinear } from 'd3-scale';
export function getDomain(data) {
    var limits = extent(data, function (d) { return d.value; });
    var domain = scaleLinear()
        .domain(limits)
        .nice()
        .domain();
    // Ensuring limits start at 0 to make scale look more `nicer`
    if (domain[0] > 0) {
        domain[0] = 0;
    }
    else if (domain[0] === 0 && domain[1] === 0) {
        // Range cannot be between 0 and 0 (itself)
        return [0, 1];
    }
    // Ensure the median of the range is 0 if domain extends into both negative & positive
    if (domain[0] < 0 && domain[1] > 0) {
        if (Math.abs(domain[0]) > domain[1]) {
            domain[1] = Math.abs(domain[0]);
        }
        else {
            domain[0] = -domain[1];
        }
    }
    return domain;
}
export function getColorScale(displayData, colorOptions) {
    var customColors = Tools.getProperty(colorOptions, 'gradient', 'colors');
    var customColorsEnabled = !Tools.isEmpty(customColors);
    var colorPairingOption = Tools.getProperty(colorOptions, 'pairing', 'option');
    // If domain consists of negative and positive values, use diverging palettes
    var domain = getDomain(displayData);
    var colorScheme = domain[0] < 0 && domain[1] > 0 ? 'diverge' : 'mono';
    // Use default color pairing options if not in defined range
    if (colorPairingOption < 1 &&
        colorPairingOption > 4 &&
        colorScheme === 'mono') {
        colorPairingOption = 1;
    }
    else if (colorPairingOption < 1 &&
        colorPairingOption > 2 &&
        colorScheme === 'diverge') {
        colorPairingOption = 1;
    }
    // Uses css classes for fill
    var colorPairing = customColorsEnabled ? customColors : [];
    if (!customColorsEnabled) {
        // Add class names to list and the amount based on the color scheme
        // Carbon charts has 11 colors for a single monochromatic palette & 17 for a divergent palette
        var colorGroupingLength = colorScheme === 'diverge' ? 17 : 11;
        for (var i = 1; i < colorGroupingLength + 1; i++) {
            colorPairing.push("fill-" + colorScheme + "-" + colorPairingOption + "-" + i);
        }
    }
    // Return generated color scale
    return scaleQuantize()
        .domain(domain)
        .range(colorPairing);
}
//# sourceMappingURL=../../src/services/color-scale-utils.js.map